export enum AddressProofType {
    aadhaar = 'aadhaar',
    passport = 'passport',
    drivinglicense = 'driving',
    voterid = 'voter',
    electricity = 'electricity',
    telephone = 'telephone',
    lpg = 'lpg'
}

export class AddressProofTypeModel {
    private static documentTypeMap = new Map<AddressProofType, string>()
        .set(AddressProofType.aadhaar, 'Masked e-Aadhaar')
        .set(AddressProofType.passport, 'Passport')
        .set(AddressProofType.drivinglicense, 'Driving License')
        .set(AddressProofType.voterid, 'Voter ID')
        .set(AddressProofType.electricity, 'Electricity bill')
        .set(AddressProofType.telephone, 'Telephone Bill - BSNL and MTNL only')
        .set(AddressProofType.lpg, 'LPG Bill');

    public static getDisplayableDocumentType(documentType: any): string {
        if (this.documentTypeMap.has(documentType)) {
            return this.documentTypeMap.get(documentType);
        } else {
            return '';
        }
    }

    public static getAllAddressProofType(): AddressProofType[] {
        return [
            AddressProofType.aadhaar,
            AddressProofType.passport,
            AddressProofType.drivinglicense,
            AddressProofType.voterid,
            AddressProofType.electricity,
            AddressProofType.telephone,
            AddressProofType.lpg
        ];
    }
}

